import CreditTableScreens from "@repo/core/screens/CreditTable";

export const SendToCreditTable = () => {
  return <CreditTableScreens.SendToCreditTable />;
};
